





























import theme from '@zk/theme/lib/variables.scss';
import { defineComponent, computed } from '@vue/composition-api';
import { useGetter } from 'common-module/src/util/useVuex';
import { useInstance } from 'common-module/src/util/useInstance';
import eventBus from '@/plugins/eventBus';

import CommonNoticeCard from '@/components/notice/CommonNoticeCard';
import * as permission from 'common-module/src/config/permission';

export default defineComponent({
  name: 'RightRecorderNoticeCard',
  components: { CommonNoticeCard },
  bemNS: theme.bemNS,
  props: {
    limitTime: {
      type: Number,
      default: 0
    }
  },
  setup(props) {
    const instance = useInstance();

    const hasUpgradePermission = computed(() => useGetter('user/checkAccessPermission')(permission.upgrade));
    const limitMinute = computed(() => Math.ceil(props.limitTime / 60));

    return {
      limitMinute,
      hasUpgradePermission,
      showActions: computed(() => hasUpgradePermission.value && !instance.$store.getters.isAWSUserMark),
      toUpgrade: () => {
        eventBus.$emit('global:openUpgradeDialog');
        instance.$parent.close();
      }
    };
  }
});
